import { render, staticRenderFns } from "./NurnbergLevel.vue?vue&type=template&id=8d37c0b4&scoped=true&"
import script from "./NurnbergLevel.vue?vue&type=script&lang=js&"
export * from "./NurnbergLevel.vue?vue&type=script&lang=js&"
import style0 from "./NurnbergLevel.vue?vue&type=style&index=0&id=8d37c0b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d37c0b4",
  null
  
)

export default component.exports